import { Mixpanel } from './mixpanel'

export const openSuggestFeatureLink = () => {
  window.open('https://ubersuggest.feedbear.com/', '_blank')

  Mixpanel.trackSuggestFeatureRedirectionSuccess()
}
